import React from "react";
import { ImageUrlPrefix } from "../../../../labels";
import { Download } from "@mui/icons-material";

const FacultyProfileStep5 = ({
  list,
  educationQualification,
  sslcCerficates,
  techQualification,
  handleChange,
  styles,
  listErrors,
  adminstatusRef,
  commentsRef,
  user_type,
}) => {
  console.log(list.Adminstatus,"list");
  
  return (

    <>
      <fieldset className="mt-3">
        <legend className="w-auto">Basic Details</legend>
        <div className="row mb-3">
          {/* LEFT SIDE: Details */}
          <div className="col-md-9">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">First Name</p>
                  <p className="confirm_value my-1">{list.FirstName || ""}</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Last Name</p>
                  <p className="confirm_value my-1">{list.LastName || "-"}</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">
                    Father's Name/Guardian's Name
                  </p>
                  <p className="confirm_value my-1">{list.Fathername || "-"}</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Date of Birth</p>
                  <p className="confirm_value my-1"> {list.DOB || "-"}</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0"> Age</p>
                  <p className="confirm_value my-1">{list.age || "-"}</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Gender</p>
                  <p className="confirm_value my-1">{list.gender || "-"}</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Place of Birth</p>
                  <p className="confirm_value my-1">{list.PlaceBirth || "-"}</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Marital Status</p>
                  <p className="confirm_value my-1">
                    {list.MaritalStatus || "-"}
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Name of the Spouse</p>
                  <p className="confirm_value my-1">{list.Spouse || "-"}</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Occupation of the Spouse</p>
                  <p className="confirm_value my-1">{list.Occupation || "-"}</p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Status</p>
                  <p className="confirm_value my-1">
                    {list.Adminstatus === 0 && <span>Email Sent</span>}
                    {list.Adminstatus === 1 && <span>Waiting For Approval</span>}
                    {list.Adminstatus === 4 && <span>Active</span>}

                    {(list.Adminstatus === 2 || list.Adminstatus === 3) && (
                      <span>InActive</span>
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE: Image */}
          <div className="col-md-3 d-flex justify-content-center align-items-start">
            {/* 
                    <div id="profilephotos"> */}
            {list.Profilephoto && (
              <img
                src={`${ImageUrlPrefix}/${list.Profilephoto}`}
                  className="profile_pic"
                alt="Profile"
                //             style={{
                //   width: "150px",
                //   height: "150px",
                //   objectFit: "contain",
                //   borderRadius: "50%",
                //   border: "1px solid #ccc",
                //   padding: "4px",
                //   backgroundColor: "#fff",
                // }}
              />
            )}
            {/* </div> */}
          </div>
        </div>
      </fieldset>

      <fieldset className="mt-3">
        <legend className="w-auto">Contact details</legend>
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Phone Number</p>
                  <p className="confirm_value my-1">{list.Mobile || "-"}</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">WhatsApp Number</p>
                  <p className="confirm_value my-1">
                    {list.WhatsAppNumber || "-"}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Email ID</p>
                  <p className="confirm_value my-1">
                    {list.emailaddress || "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset className="mt-3">
        <legend className="w-auto">ID Proofs</legend>
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">AADHAR Number</p>
                  <p className="confirm_value my-1">{list.aadharNo || "-"}</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">
                    {" "}
                    Upload AADHAR Card
                    {list.aadharCardphoto && (
                      <a href={`${ImageUrlPrefix}/${list.aadharCardphoto}`}>
                        {" "}
                        <Download className="download_icon" />
                      </a>
                    )}
                  </p>
                  <p className="confirm_value my-1">
                    {list.original_aadhar_path || "-"}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0"> PAN Number</p>
                  <p className="confirm_value my-1">{list.panNo || "-"}</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">
                    {" "}
                    Uploaded PAN Card
                    {list.panPhoto && (
                      <a href={`${ImageUrlPrefix}/${list.panPhoto}`}>
                        {" "}
                        <Download className="download_icon" />
                      </a>
                    )}
                  </p>
                  <p className="confirm_value my-1">
                    {list.original_pan_path || "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <div className="row">
        {/* Present Address */}
        <div className="col-md-6">
          <fieldset className="mt-3">
            <legend className="w-auto">Present Address</legend>
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="forms mb-2">
                  <p className="confirm_label m-0">Present Address</p>
                  <p className="confirm_value my-1">
                    <span className="">
                      {list.BuildingNumberPresent || "-"}
                      {list.BuildingNumberPresent ? ", " : ""}
                      {list.StreetNamePresent || "-"}
                    </span>
                  </p>
                </div>

                <div className="forms mb-2">
                  <p className="confirm_value my-1">
                    <span className="">
                      {list.AreaPresent || "-"}
                      {list.AreaPresent ? ", " : ""}
                      {list.LandmarkPresent || "-"}
                    </span>
                  </p>
                </div>

                <div className="forms mb-2">
                  <p className="confirm_value my-1">
                    {" "}
                    <span className="">
                      {list.TalukPresent || "-"}
                      {list.TalukPresent ? ", " : ""}
                      {list.PostPresent || "-"}
                    </span>
                  </p>
                </div>

                <div className="forms mb-2">
                  <p className="confirm_value my-1">
                    {" "}
                    <span className="">
                      {list.PincodePresent || "-"}
                      {list.PincodePresent ? ", " : ""}
                      {list.CityPresent || "-"}
                    </span>
                  </p>
                </div>

                <div className="forms mb-2">
                  <p className="confirm_value my-1">
                    <span className="">
                      {list.districtPresent || "-"}
                      {list.districtPresent ? ", " : ""}
                      {list.statePresent || "-"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>

        {/* Permanent Address */}
        <div className="col-md-6">
          <fieldset className="mt-3">
            <legend className="w-auto">Permanent Address</legend>
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="forms mb-2">
                  <p className="confirm_label m-0">Permanent Address</p>
                  <p className="confirm_value my-1">
                    <span className="">
                      {list.BuildingNumberPermanent || "-"}
                      {list.BuildingNumberPermanent ? ", " : ""}
                      {list.StreetNamePermanent || "-"}
                    </span>
                  </p>
                </div>

                <div className="forms mb-2">
                  <p className="confirm_value my-1">
                    {" "}
                    <span className="">
                      {list.AreaPermanent || "-"}
                      {list.AreaPermanent ? ", " : ""}
                      {list.LandmarkPermanent || "-"}
                    </span>
                  </p>
                </div>

                <div className="forms mb-2">
                  <p className="confirm_value my-1">
                    {" "}
                    <span className="">
                      {list.TalukPermanent || "-"}
                      {list.TalukPermanent ? ", " : ""}
                      {list.PostPermanent || "-"}
                    </span>
                  </p>
                </div>

                <div className="forms mb-2">
                  <p className="confirm_value my-1">
                    {" "}
                    <span className="">
                      {list.PincodePermanent || "-"}
                      {list.PincodePermanent ? ", " : ""}
                      {list.CityPermanent || "-"}
                    </span>
                  </p>
                </div>

                <div className="forms mb-2">
                  <p className="confirm_value my-1">
                    <span className="">
                      {list.districtPermanent || "-"}
                      {list.districtPermanent ? ", " : ""}
                      {list.statePermanent || "-"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>

      {educationQualification.includes("UG") && (
        <fieldset className="mt-3">
          <legend className="w-auto">UG</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Certificate Number</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[0].UGCertificateNumber || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Year of Passing</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[0].UGYearpassing || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Degree</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[0].UGDegree || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Major</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[0].UGMajor || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Marks Percentage</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[0].UGMarksPercentage || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Class</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[0].UGClassName || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Name of the college / university
                    </p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[0].UGNameInstitute || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Uploaded UG Certificate
                      {sslcCerficates[0].UG_Path && (
                        <a
                          target="_blank"
                          href={`${ImageUrlPrefix}/${sslcCerficates[0].UG_Path}`}
                        >
                          {" "}
                          <Download className="download_icon" />
                        </a>
                      )}
                    </p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[0].original_file_path || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      )}

      {educationQualification.includes("PG") && (
        <fieldset className="mt-3">
          <legend className="w-auto">PG</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Certificate Number</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[1].PGCertificateNumber || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Year of Passing</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[1].PGYearpassing || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Degree</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[1].PGDegree || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Major</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[1].PGMajor || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Marks Percentage</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[1].PGMarksPercentage || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Class</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[1].PGClassName || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Name of the college / university
                    </p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[1].PGNameInstitute || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Uploaded UG Certificate
                      {sslcCerficates[1].PG_Path && (
                        <a
                          target="_blank"
                          href={`${ImageUrlPrefix}/${sslcCerficates[1].PG_Path}`}
                        >
                          {" "}
                          <Download className="download_icon" />
                        </a>
                      )}
                    </p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[1].original_file_path || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      )}

      {educationQualification.includes("Integrated PG") && (
        <fieldset className="mt-3">
          <legend className="w-auto">Integrated PG</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Certificate Number</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[2].IPCertificateNumber || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Year of Passing</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[2].IPYearpassing || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Degree</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[2].IPDegree || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Major</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[2].IPMajor || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Marks Percentage</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[2].IPMarksPercentage || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Class</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[2].IPClassName || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Name of the college / university
                    </p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[2].IPNameInstitute || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Uploaded UG Certificate
                      {sslcCerficates[2].IP_Path && (
                        <a
                          target="_blank"
                          href={`${ImageUrlPrefix}/${sslcCerficates[2].IP_Path}`}
                        >
                          {" "}
                          <Download className="download_icon" />
                        </a>
                      )}
                    </p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[2].original_file_path || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      )}

      {educationQualification.includes("phd") && (
        <fieldset className="mt-3">
          <legend className="w-auto">PHD</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Certificate Number</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[3].PHDCertificateNumber || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Year of Passing</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[3].PHDYearpassing || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Degree</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[3].PHDDegree || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Major</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[3].PHDMajor || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Marks Percentage</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[3].PHDMarksPercentage || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Class</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[3].PHDClassName || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Name of the college / university
                    </p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[3].PHDNameInstitute || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Uploaded UG Certificate
                      {sslcCerficates[3].PHD_Path && (
                        <a
                          target="_blank"
                          href={`${ImageUrlPrefix}/${sslcCerficates[3].PHD_Path}`}
                        >
                          {" "}
                          <Download className="download_icon" />
                        </a>
                      )}
                    </p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[3].original_file_path || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      )}

      {educationQualification.includes("Diploma") && (
        <fieldset className="mt-3">
          <legend className="w-auto">Diploma</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Certificate Number</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[4].DCertificateNumber || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Year of Passing</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[4].DYearpassing || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Degree</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[4].DDegree || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Major</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[4].DMajor || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Marks Percentage</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[4].DMarksPercentage || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Class</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[4].DClassName || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Name of the college / university
                    </p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[4].DNameInstitute || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Uploaded UG Certificate
                      {sslcCerficates[4].D_Path && (
                        <a
                          target="_blank"
                          href={`${ImageUrlPrefix}/${sslcCerficates[4].D_Path}`}
                          className="ms-2"
                        >
                          <Download className="download_icon" />
                        </a>
                      )}
                    </p>

                    <p className="confirm_value my-1">
                      {sslcCerficates[4].original_file_path || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      )}

      {educationQualification.includes("Professional Courses") && (
        <fieldset className="mt-3">
          <legend className="w-auto">Professional Courses</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Certificate Number</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[5].PCCertificateNumber || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Year of Passing</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[5].PCYearpassing || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Degree</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[5].PCDegree || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Major</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[5].PCMajor || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Marks Percentage</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[5].PCMarksPercentage || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Class</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[5].PCClassName || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Name of the college / university
                    </p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[5].PCNameInstitute || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Uploaded UG Certificate
                      {sslcCerficates[5].PC_Path && (
                        <a
                          target="_blank"
                          href={`${ImageUrlPrefix}/${sslcCerficates[5].PC_Path}`}
                          className="ms-2"
                        >
                          <Download className="download_icon" />
                        </a>
                      )}
                    </p>

                    <p className="confirm_value my-1">
                      {sslcCerficates[5].original_file_path || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      )}

      {educationQualification.includes("Others") && (
        <fieldset className="mt-3">
          <legend className="w-auto">Others</legend>
          <div className="row mb-3">
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Certificate Number</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[6].OtCertificateNumber || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Year of Passing</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[6].OtYearpassing || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0"> Degree</p>
                    <p className="confirm_value my-1">
                      {" "}
                      {sslcCerficates[6].OtDegree || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Major</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[6].OtMajor || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Marks Percentage</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[6].OtMarksPercentage || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">Class</p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[6].OtClassName || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Name of the college / university
                    </p>
                    <p className="confirm_value my-1">
                      {sslcCerficates[6].OtNameInstitute || "-"}
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-12 mb-3">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0">
                      Uploaded UG Certificate
                      {sslcCerficates[6].Ot_Path && (
                        <a
                          target="_blank"
                          href={`${ImageUrlPrefix}/${sslcCerficates[6].Ot_Path}`}
                          className="ms-2"
                        >
                          <Download className="download_icon" />
                        </a>
                      )}
                    </p>

                    <p className="confirm_value my-1">
                      {sslcCerficates[6].original_file_path || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      )}

      {techQualification.map((el, index) => (
        <div className="col-md-12" key={index}>
          <fieldset className="mt-3">
            <legend className="w-auto">
              Technical Qualification{" "}
              {techQualification.length > 1 ? `- ${index + 1}` : ""}
            </legend>

            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row">
                  {/* Technical Course */}
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Technical Course</p>
                      <p className="confirm_value my-1">{el.name || "-"}</p>
                    </div>
                  </div>

                  {/* Typewriting Level */}
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Typewriting Level</p>
                      <p className="confirm_value my-1">{el.level || "-"}</p>
                    </div>
                  </div>

                  {/* Language */}
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Language</p>
                      <p className="confirm_value my-1">{el.lang || "-"}</p>
                    </div>
                  </div>

                  {/* Certificate Number */}
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Certificate Number</p>
                      <p className="confirm_value my-1">{el.Cnum || "-"}</p>
                    </div>
                  </div>

                  {/* Grade */}
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Grade</p>
                      <p className="confirm_value my-1">{el.grade || "-"}</p>
                    </div>
                  </div>

                  {/* Year of Passing */}
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">Year of Passing</p>
                      <p className="confirm_value my-1">{el.year || "-"}</p>
                    </div>
                  </div>

                  {/* Upload Certificate */}
                  <div className="col-lg-3 col-md-6 col-12 mb-3">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0">
                        Upload Certificate
                        {el.file && (
                          <a
                            target="_blank"
                            href={`${ImageUrlPrefix}/${el.file}`}
                            rel="noopener noreferrer"
                          >
                            <Download
                              className="download_icon"
                              style={{ opacity: 1 }}
                            />
                          </a>
                        )}
                      </p>
                      <p className="confirm_value my-1">
                        {el.original_file_path || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      ))}

      <fieldset className="mt-3">
        <legend className="w-auto">
          {" "}
          Special / Preferential Qualification (if any)
        </legend>
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">
                    Special / Preferential Qualification
                  </p>
                  <p className="confirm_value my-1">{list.spq || "-"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset className="mt-3">
        <legend className="w-auto">Previous Experience</legend>
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">
                    Do you have any previous working or teaching experience?
                  </p>
                  <p className="confirm_value my-1">
                    {list.prevTeachexp === "Yes" ? "Yes" : "No" || "-"}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Working Experience</p>
                  <p className="confirm_value my-1">
                    {list.prevTeachexp === "Yes" ? list.workingexp : "-"}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0"> Teaching Experience</p>
                  <p className="confirm_value my-1">
                    {" "}
                    {list.prevTeachexp === "Yes" ? list.teachexp : "-"}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">
                    Working Experience File{" "}
                    {list.working_ex_file !== "" &&
                      list.working_ex_file !== null && (
                        <a
                          href={`${ImageUrlPrefix}/${list.working_ex_file}`}
                          target="_blank"
                          download
                        >
                          <span className="material-icons align-middle download_icon">
                            file_download
                          </span>
                        </a>
                      )}
                  </p>
                  <p className="confirm_value my-1">
                    {list.prevTeachexp === "Yes" ? list.original_workexp : "-"}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">
                    Teaching Experience File{" "}
                    {list.Teaching_ex_file !== "" &&
                      list.Teaching_ex_file !== null && (
                        <a
                          href={`${ImageUrlPrefix}/${list.Teaching_ex_file}`}
                          target="_blank"
                          download
                        >
                          <span className="material-icons align-middle download_icon">
                            file_download
                          </span>
                        </a>
                      )}
                  </p>
                  <p className="confirm_value my-1">
                    {list.prevTeachexp === "Yes" ? list.original_teachexp : "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset className="mt-3">
        <legend className="w-auto">Current Job Info</legend>
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Job Type</p>
                  <p className="confirm_value my-1">
                    {list.teachType === "1" ? "Teaching" : "NonTeaching" || "-"}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Designation</p>
                  <p className="confirm_value my-1">
                    {list.designation || "-"}
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Date of Joining</p>
                  <p className="confirm_value my-1">{list.DJoin || "-"}</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Branch Location</p>
                  <p className="confirm_value my-1">
                    {list.location_name || "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset className="mt-3">
        <legend className="w-auto">Voice Your Opinion</legend>
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-12 mb-3">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0">Insights and Proposals</p>
                  <p className="confirm_value my-1">
                    {list.VoiceOpinion || "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      {/* Review by Admin */}
      {user_type === 1 && (
        <fieldset className="mt-3">
          <legend className="w-auto">Review by Admin</legend>
          <form className="row g-3">
            {/* Employee Status */}
            <div className="col-md-12">
              <label className="form-label confirm_value">
                Employee Status
              </label>
              <div>
                {["Active", "Hold", "Reject"].map((option) => {
                  const valueMap = {
                    Active: "4",
                    Hold: "2",
                    Reject: "3",
                  };

                  const radioId = `adminstatus-${option.toLowerCase()}`;

                  return (
                    <React.Fragment key={option}>
                      <input
                        ref={adminstatusRef}
                        className={`shadow-none input-font-size ${styles.checkbox_radio}`}
                        type="radio"
                        name="Adminstatus"
                        id={radioId}
                        value={valueMap[option]}
                        checked={list.Adminstatus == valueMap[option]}
                        onChange={handleChange}
                      />
                      <label
                        className="form-label confirm_value me-3"
                        htmlFor={radioId}
                      >
                        {option}
                      </label>
                    </React.Fragment>
                  );
                })}
              </div>
              {listErrors.Adminstatus && (
                <small className="error_message">
                  {listErrors.Adminstatus}
                </small>
              )}
            </div>

            {/* Comments */}
            <div className="col-md-12">
              <label htmlFor="comments" className="form-label confirm_value">
                Comments
              </label>
              <textarea
                ref={commentsRef}
                className="Inputs w-100 rounded-2 input-font-size-sm"
                name="comments"
                id="comments"
                onChange={handleChange}
                value={list.comments}
                placeholder="Comments"
              ></textarea>
              {listErrors.comments && (
                <small className="error_message">{listErrors.comments}</small>
              )}
            </div>
          </form>
        </fieldset>
      )}
    </>
  );
};

export default FacultyProfileStep5;
